(function () {
  'use strict';

  angular
    .module('flightScreen')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('flightScreen', {
        url: '/flight-screen',
        templateUrl: 'flight-screen/views/flight-screen.tpl.html',
        controller: 'FlightScreenCtrl',
        controllerAs: 'flightScreen'
      });
  }
}());
